import { ComponentProps } from 'react';
import { CONTACT_SALES_LINK } from 'constants/links';
import { twMerge } from 'tailwind-merge';

interface ChatWithSalesProps extends ComponentProps<'div'> {}
const ChatWithSales = ({ className, ...rest }: ChatWithSalesProps) => {
    return (
        <div
            className={twMerge('flex flex-col gap-3 rounded-lg bg-gray-100 p-4', className)}
            {...rest}
        >
            <div className="text-sm text-gray-700">
                <p className="font-medium">Is Givebutter Plus right for you?</p>
                <p>Schedule a free consultation to see whether you should make the switch!</p>
            </div>
            <div>
                <a
                    className="inline-block rounded-lg border border-gray-300 bg-white px-3 py-2 text-center text-sm font-medium text-gray-700 !transition-none hover:bg-gray-100 hover:text-gray-700"
                    href={CONTACT_SALES_LINK}
                    target="_blank"
                    rel="noreferrer"
                >
                    Chat with sales
                </a>
            </div>
        </div>
    );
};

export { ChatWithSales };
